export const SET_EDMI_SERIAL = "SET_EDMI_SERIAL";
export const CLEAR_EDMI_SERIAL = "CLEAR_EDMI_SERIAL";

export function setEdmiSerial(serial) {
  return {
    type: SET_EDMI_SERIAL,
    payload: {
      serial,
    },
  };
}

export function clearEdmiSerial() {
  return {
    type: CLEAR_EDMI_SERIAL,
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/edmi.js